<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form 
      :model="form" 
      :rules="rules" 
      ref="form" 
      label-width="100px"
      status-icon
    >
      <el-form-item label="当前密码" prop="oldPassword">
        <el-input 
          v-model="form.oldPassword" 
          type="password" 
          placeholder="请输入当前密码"
          show-password
        />
      </el-form-item>
      
      <el-form-item label="新密码" prop="newPassword">
        <el-input 
          v-model="form.newPassword" 
          type="password" 
          placeholder="请输入新密码（至少6位）"
          show-password
        />
      </el-form-item>
      
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input 
          v-model="form.confirmPassword" 
          type="password" 
          placeholder="请再次输入新密码"
          show-password
        />
      </el-form-item>
    </el-form>
    
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit" 
        :loading="loading"
      >
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { authApi } from '@/api'

export default {
  name: 'ChangePasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 自定义验证：确认密码与新密码一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.resetForm()
    },
    
    resetForm() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
    },
    
    async handleSubmit() {
      try {
        // 表单验证
        await this.$refs.form.validate()
        
        this.loading = true
        
        // 调用修改密码接口
        await authApi.changePassword({
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword
        })
        
        this.$message.success('密码修改成功，请重新登录')
        
        // 延迟后强制退出登录
        setTimeout(() => {
          this.$store.dispatch('logout')
          this.$router.push('/login')
        }, 1500)
        
      } catch (error) {
        const msg = error.response?.data?.message || '密码修改失败'
        this.$message.error(msg)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>